<div class="container-fluid py-5 donor-container">
  <div class="text-center mb-5">
    <h2 class="fw-bold text-gradient">Donor Details</h2>
    <p class="text-muted">Track all contributions in one place</p>
  </div>

  <!-- Filter Bar -->
  <div class="row g-4 mb-4 filter-bar">
    <div class="col-md-3">
      <label class="fw-semibold mb-1">Payment Status</label>
      <select class="form-select stylish-input" [(ngModel)]="selectedStatus" (change)="applyFilters()">
        <option value="">All</option>
        <option value="PAID">Paid</option>
        <option value="NOT_PAID">Not Paid</option>
      </select>
    </div>

    <div class="col-md-3">
      <label class="fw-semibold mb-1">Date</label>
      <input type="date" class="form-control stylish-input" [(ngModel)]="selectedDate" (change)="applyFilters()">
    </div>

    <div class="col-md-3">
      <label class="fw-semibold mb-1">Total Paid Amount</label>
      <div class="total-amount-box bg-light rounded px-3 py-2 shadow-sm d-flex align-items-center">
        <span class="currency fw-bold text-success me-1">$</span>
        <span class="fw-semibold">{{ totalPaidAmount.toFixed(2) }}</span>
      </div>
    </div>

    <div class="col-md-3">
      <label class="fw-semibold mb-1">Search Donor</label>
      <input type="text" class="form-control stylish-input" [(ngModel)]="searchTerm" (input)="applyFilters()"
        placeholder="Search by name or email">
    </div>
  </div>

  <!-- Donor Table -->
  <div class="card glass-card border-0 shadow-lg rounded-4 p-3">
    <div class="table-responsive table-scroll-wrapper">
      <table class="table table-hover stylish-table align-middle mb-0">
        <thead class="text-white table-header">
          <tr>
            <th class="text-center">Sr.No</th>
            <th class="text-center">Donor Name</th>
            <th class="text-center">Email Address</th>
            <th class="text-center">Phone Number</th>
            <th class="text-center">Payment Status<span class="text-danger">*</span></th>
            <th class="text-center">Transaction ID</th>
            <th class="text-center">Payment Date</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let sponsor of filteredDonates; let i = index" class="table-row bg-white bg-opacity-75">
            <td class="fw-bold text-center">{{ i + 1 }}</td>
            <td class="donor-name text-center">{{ sponsor.firstName }} {{ sponsor.lastName }}</td>
            <td class="text-center">{{ sponsor.emailAddress }}</td>
            <td class="text-center">{{ sponsor.phoneNumber }}</td>
            <td class="text-center">
              <span class="badge" [ngClass]="{
                  'bg-danger': sponsor.paymentStatus !== 'PAID',
                  'bg-success': sponsor.paymentStatus === 'PAID'
                }" (click)="paymentUpdate(sponsor.paymentStatus, sponsor.sponsorDetailsId)" style="cursor: pointer;">
                {{ sponsor.paymentStatus === 'PAID' ? 'Paid' : 'Not Paid' }}
              </span>
            </td>
            <td class="text-center">{{ getTransactionId(sponsor) }}</td>
            <td class="text-center">{{ getTransactionDate(sponsor) }}</td>
          </tr>
          <tr *ngIf="filteredDonates.length === 0">
            <td colspan="7" class="text-center text-muted py-4">No donors found</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

  <!-- Sponsor Payment Modal -->
  <div class="modal" id="sponsorModal" [style.display]="adminSponsorModal ? 'block' : 'none'" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content">
        <div class="modal-header bg-success text-white">
          <h5 class="modal-title">Transaction Details</h5>
          <button type="button" class="btn-close btn-close-white" aria-label="Close"
            (click)="openingSponsor()"></button>
        </div>
        <div class="modal-body">
          <div class="alert alert-warning d-flex align-items-center mb-3" *ngIf="!selectedSponsor?.paymentStatus">
            <i class="bi bi-info-circle-fill me-2"></i>
            No transaction details available.
          </div>

          <div class="card border-0 shadow-sm">
            <div class="card-body">
              <h6 class="card-title mb-3 d-flex align-items-center">
                <i class="bi bi-pencil-square text-primary me-2 fs-5"></i>
                Update Payment Status
              </h6>

              <div class="mb-3">
                <label class="form-label fw-semibold">Select Payment Status</label>
                <select class="form-select" [(ngModel)]="newPaymentStatus">
                  <option value="PAID">Paid</option>
                  <option value="NOT_PAID">Not Paid</option>
                </select>
              </div>

              <button class="btn btn-success rounded-pill px-4" (click)="confirmPaymentUpdate()">
                <i class="bi bi-save me-2"></i>Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium">
  <div class="loader">
    <div class="inner one"></div>
    <div class="inner two"></div>
    <div class="inner three"></div>
  </div>
</ngx-spinner>